// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__JnboM","left":"StickyBox_left__3lDTA","right":"StickyBox_right__3ln5k"};